//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goldBoxEcuComparisonQuery from '~/apollo/queries/product/gold-box-ecu-comparison'

export default {
  apollo: {
    goldBoxEcuComparison: {
      prefetch: true,
      query: goldBoxEcuComparisonQuery
    }
  }
}
